import { Tooltip } from "antd";
import { ParkingRevenueStatsByDate, ParkingRevenueStatsSummary } from "../api/models";
import ParkingRevenueBreakdown from "./ParkingRevenueBreakdown";
import { useState } from "react";

export interface Props {
    stats: ParkingRevenueStatsSummary[];
    parkingRevenue: ParkingRevenueStatsByDate[];
}

export const ParkingRevenueSummary = (props: Props) => {
    const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const [parkingRevenueBreakdown, setParkingRevenueBreakdown] = useState<string>();
    const sortedStats = [...props.stats].sort((a, b) => b.revenue - a.revenue);

    function getRevenueTooltip(s: ParkingRevenueStatsSummary) {
        const formatted = currencyFormat.format(s.revenueOriginalCurrency / 100);
        let currency = 'USD';
        if (s.provider.indexOf('sedo') !== -1) currency = 'EUR';
        return formatted + ' ' + currency;
    }

    return (
        <div>
            <table className="w-full">
                <thead>
                    <tr>
                        <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-1 px-2">Provider</th>
                        <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-1 px-2">Revenue</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedStats.map((s) => (
                        <tr key={s.provider} className="border-t border-border hover:bg-bg-elevated transition-colors">
                            <td className="py-1 px-2">
                                <button
                                    type="button"
                                    onClick={() => setParkingRevenueBreakdown(s.provider)}
                                    className="text-accent text-sm hover:opacity-80 cursor-pointer"
                                >
                                    {s.provider}
                                </button>
                            </td>
                            <td className="py-1 px-2 text-right">
                                <Tooltip title={getRevenueTooltip(s)}>
                                    <span className="font-mono text-sm text-text tabular-nums">
                                        {currencyFormat.format(s.revenue / 100)}
                                    </span>
                                </Tooltip>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {parkingRevenueBreakdown && (
                <ParkingRevenueBreakdown
                    onClose={() => setParkingRevenueBreakdown(undefined)}
                    data={props.parkingRevenue}
                    provider={parkingRevenueBreakdown}
                />
            )}
        </div>
    );
};
